// Decides whether a single menu item (or section) is visible for the running
// backend. Today the only rule is the system tag; add further predicate cases
// here (e.g. per-feature toggles) as config grows.
//
// An item with no `systems` field is universal and always shown. An item with a
// `systems` array is shown only when at least one of those system ids is present
// in the backend's configured `systems[]`. When `systems` is null (not yet
// fetched / local dev), every item is shown.
export function isItemVisible(item, systems) {
  if (!item.systems) return true;
  if (!systems) return true;
  return item.systems.some((id) => systems.includes(id));
}

// Filters a menu (array of { section, items } groups) for the running backend.
// Non-matching items are dropped; sections that end up empty are removed.
export function filterMenu(menu, systems) {
  return menu
    .filter((section) => isItemVisible(section, systems))
    .map((section) => ({
      ...section,
      items: (section.items || []).filter((item) =>
        isItemVisible(item, systems)
      ),
    }))
    .filter((section) => section.items.length > 0);
}
